import { FC } from "react";

const retry = (fn: () => Promise<any>, retriesLeft: number = 5, interval: number = 2000): Promise<{ default: FC<any>; }> => {
  return new Promise((resolve, reject) => {
    return fn()
      .then(resolve)
      .catch((error) => {
        if (retriesLeft === 1) {
          document.location.reload();
          reject(error);
          return;
        }

        setTimeout(() => {
          retry(fn, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });
};

export default retry;